<div [formGroup]="form">
  <div class="form-spacing">
    <!-- Data richiesta (View only) -->
    <div class="column">
      <label class="label">{{ 'pre-employment.selfservice.declaration-date.label' | translate }}</label>
      <p class="text-dark">{{ form.get('createdAt')?.value | date: 'dd/MM/yyyy' }}</p>
    </div>

    <!-- Note / Dichiarazione -->
    <div class="column">
      <p class="text-dark" [innerHTML]="'selfservice-request.retirement-plan.notes.label' | translate"></p>
    </div>

    <!-- Pre1996 / Post1995: iscrizione a forme pensionistiche (una sola opzione) -->
    <div class="column">
      <!-- Pre1996: da una data antecedente il 1° gennaio 1996 -->
      <div class="row gap-small mb-2">
        <p-radiobutton
          inputId="contributionsBefore1996True"
          formControlName="contributionsBefore1996"
          [value]="true"
        ></p-radiobutton>
        <label for="contributionsBefore1996True" class="label">
          {{ 'selfservice-request.retirement-plan.contributions-date.before-1996.label' | translate }}
        </label>
      </div>

      <!-- Post1995: da una data successiva al 31/dicembre 1995 -->
      <div class="row gap-small">
        <p-radiobutton
          inputId="contributionsBefore1996False"
          formControlName="contributionsBefore1996"
          [value]="false"
        ></p-radiobutton>
        <label for="contributionsBefore1996False" class="label">
          {{ 'selfservice-request.retirement-plan.contributions-date.after-1995.label' | translate }}
        </label>
      </div>
    </div>
  </div>
</div>
